var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-block"},[_c('div',{staticClass:"icon-circle"},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":'#'+ _vm.icon}})])]),(_vm.icon)?_c('p'):_vm._e(),_c('div',{staticClass:"desc"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }